import * as moment from 'moment';

export interface IPageModel {
  id?: number;
  name: string;
  code: string;
  application_id: number;
  description?: string;
  is_enabled: boolean;
  created?: moment.Moment;
  modified?: moment.Moment;
}

export interface IResultPageModel {
  count: number;
  next: string;
  previous: string;
  results: IPageModel[];
}

export class PageModel {
  id?: number;
  name: string;
  code: string;
  applicationId: number;
  description?: string;
  is_enabled: boolean;
  created?: moment.Moment;
  modified?: moment.Moment;

  constructor() {
    this.is_enabled = true;
  }

  static fromObject(page: IPageModel): PageModel {
    let obj = new PageModel();
    obj.id = page.id;
    obj.name = page.name;
    obj.code = page.code;
    obj.applicationId = page.application_id;
    obj.description = page.description;
    obj.is_enabled = page.is_enabled;
    obj.created = moment(page.created);
    obj.modified =  moment(page.modified);
    return obj;
  }

  static fromObjectArray(pages: IPageModel[]): PageModel[] {
    return pages.map((page: IPageModel) => PageModel.fromObject(page));
  }

}

export class ResultPageModel {
  count: number = 0;
  next: string;
  previous: string;
  results: PageModel[] = [];

  static fromObject(result: IResultPageModel): ResultPageModel {
    let obj = new ResultPageModel();
    obj.count = result.count | 0;
    obj.next = result.next;
    obj.previous = result.previous;
    obj.results = (result.results && result.results.length > 0) ? PageModel.fromObjectArray(result.results) : [];
    return obj;
  }
}
